import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Address, AddressMapComponent, CrudService, Dispatch, Dispatchactionlog, MessageService, ModalWrapperComponent, Search, workaroundClickEventDatatable } from 'orv-ui-base-lib';
import { forkJoin } from 'rxjs';


@Component({
	selector: 'app-trip-actions-log-modal',
	templateUrl: './trip-actions-log-modal.component.html',
	styleUrls: ['./trip-actions-log-modal.component.scss']
})
export class TripActionsLogModalComponent implements OnInit {

	trip: Dispatch;
	rows: Dispatchactionlog[] = [];
	loading: boolean = false;
	advancedSearch: Search = new Search('dispatchactionlog');

	constructor(
		private $t: TranslateService,
		private activeModal: NgbActiveModal,
		private modalService: NgbModal,
		private crudService: CrudService<Dispatchactionlog>,
		private messageService: MessageService,
	) {}

	ngOnInit() {
		this.load();
	}

	load() {
		this.loading = true;
		this.advancedSearch.addSimpleFilter('did', this.trip.id);

		const datarequest = this.crudService.searchEntities(Dispatchactionlog, 'dispatchactionlog', this.advancedSearch, this.advancedSearch.page);
		const countrequest = this.crudService.countEntities(Dispatchactionlog, 'dispatchactionlog', this.advancedSearch);

		forkJoin([datarequest, countrequest]).subscribe(results => {
			this.advancedSearch.page.setTotal(results[1].ct);
			this.rows = results[0];
			this.loading = false;
		}, ({ error }) => {
			this.messageService.sendError(error && error.msg ? error.msg : '', this.$t.instant('labels.actionslog'));
			this.loading = false;
		});
	}

	onPageChange(pageInfo: any) {
		this.advancedSearch.page.setPageNumber(pageInfo.offset);
		this.load();
	}

	onSortChange(sortInfo: any) {
		const sort = sortInfo.sorts[0];
		this.advancedSearch.setSortField(sort.prop);
		this.advancedSearch.setSortDirection(sort.dir);
		this.load();
	}

	close() {
		this.activeModal.close();
	}

	dismiss() {
		this.activeModal.dismiss();
	}

	showMap(row: Dispatchactionlog, event: any) {
		workaroundClickEventDatatable(event);

		const address: Address = new Address();
		address.lat = row.lat;
		address.lng = row.lng;

		const modal = this.modalService.open(ModalWrapperComponent, {
			centered: true, size: 'lg', backdrop: 'static', keyboard: false
		});
		modal.componentInstance.component = AddressMapComponent;
		modal.componentInstance.title = this.$t.instant('labels.actionslog-map');
		modal.componentInstance.inputs = {
			address,
			editable: false,
			markerIcon: 'assets/images/map/markers/marker_pause.svg'
		};
	}

}
